module.exports = __webpack_public_path__ + "static/img/award2_active.83f646c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index/award2_active.png
// module id = TFjs
// module chunks = 7